import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PanService } from '../../core/services/pan.service';

export interface PanLiteData {
  clientId: string;
  panNumber: string;
  fullName: string;
  category: string;
}

export interface ReportOverviewState {
  pan: string;
  confirmedName: string;
  panLiteData: PanLiteData;
}

export interface PanVerifyResultDialogData {
  pan: string;
  latestRecord: boolean;
}

@Component({
  selector: 'app-pan-verify-result',
  templateUrl: './pan-verify-result.component.html',
  styleUrls: ['./pan-verify-result.component.scss']
})
export class PanVerifyResultComponent implements OnInit {
  organizationName: string = '';
  pan: string = '';
  reportOverviewState: ReportOverviewState | null = null;

  constructor(
    public dialogRef: MatDialogRef<PanVerifyResultComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PanVerifyResultDialogData,
    private router: Router,
    private panService: PanService
  ) {
    this.pan = data.pan;
  }

  ngOnInit(): void {
    if (this.pan) {
      this.fetchPanDetails();
    }
  }

  fetchPanDetails(): void {
    this.panService.verifyPan(this.pan, this.data.latestRecord).subscribe((response: any) => {
      const apiResponse = response?.data ?? {};
      this.organizationName = apiResponse?.organizationName;

      this.reportOverviewState = {
        pan: apiResponse?.pan,
        confirmedName: apiResponse?.organizationName,
        panLiteData: apiResponse?.panLiteData
      };
    });
  }

  onConfirm(): void {
    if (!this.pan || !this.reportOverviewState) return;
    this.dialogRef.close({ action: 'confirm', reportOverviewState: this.reportOverviewState });
    this.router.navigate(['/ngo-diligence'], {
      state: { reportOverviewState: this.reportOverviewState }
    });
  }

  onCancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }
}

